module.exports = __webpack_public_path__ + "media/images/pic/godzilla-2eae68768a2fd221422084808ce4645e.webp";